"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAppointmentQuery = exports.setValidatedDateOfBirth = exports.setLoadingMachineData = exports.setApptTimeMachine = exports.setDobConfirmationMachine = exports.setLoadingMachine = void 0;
const xstate_1 = require("xstate");
const loadingMachine_1 = require("./loadingMachine/loadingMachine");
const dobConfirmationMachine_1 = require("./dobConfirmationMachine/dobConfirmationMachine");
const apptTIme_1 = require("../../../ManageAppointment/stateMachine/machines/apptTime/apptTIme");
// Action constants
const setLoadingMachine = '@action/SET_LOADING_MACHINE';
exports.setLoadingMachine = setLoadingMachine;
const setDobConfirmationMachine = '@action/SET_DOB_CONFIRMATION_MACHINE';
exports.setDobConfirmationMachine = setDobConfirmationMachine;
const setApptTimeMachine = '@action/SET_APPT_TIME_MACHINE';
exports.setApptTimeMachine = setApptTimeMachine;
const setLoadingMachineData = '@action/SET_LOADING_MACHINE_DATA';
exports.setLoadingMachineData = setLoadingMachineData;
const setAppointmentQuery = '@action/SET_APPOINTMENT_QUERY';
exports.setAppointmentQuery = setAppointmentQuery;
const setValidatedDateOfBirth = '@action/SET_DATE_RESPONSE';
exports.setValidatedDateOfBirth = setValidatedDateOfBirth;
// Actions object using string constants as keys, with explicit typing
const actions = {
    [setLoadingMachine]: (0, xstate_1.assign)({
        loadingMachine: (context) => {
            return (0, xstate_1.spawn)((0, loadingMachine_1.createAppointmentWaitlistLoadingMachine)({
                appointmentWaitlistId: context.appointmentWaitlistId,
                waitlist: context.waitlist,
                provider: context.provider,
                services: {
                    getWaitlistDetails: context.services.getWaitlistDetails,
                    getProvider: context.services.getProvider
                }
            }));
        }
    }),
    [setLoadingMachineData]: (0, xstate_1.assign)({
        waitlist: (_ctx, event) => { var _a; return (_a = event.data) === null || _a === void 0 ? void 0 : _a.waitlist; },
        provider: (_ctx, event) => { var _a; return (_a = event.data) === null || _a === void 0 ? void 0 : _a.provider; }
    }),
    [setDobConfirmationMachine]: (0, xstate_1.assign)({
        dobConfirmationMachine: (context) => {
            return (0, xstate_1.spawn)((0, dobConfirmationMachine_1.createDateOfBirthConfirmationMachine)({
                waitlist: context.waitlist,
                provider: context.provider,
                dateOfBirth: undefined
            }));
        }
    }),
    [setApptTimeMachine]: (0, xstate_1.assign)((context) => {
        var _a, _b, _c, _d;
        if (!context.provider) {
            throw new Error('Appointment and provider must be set before setting reason machine');
        }
        return {
            apptTimeMachine: (0, xstate_1.spawn)((0, apptTIme_1.createApptTimeMachine)({
                provider: context.provider,
                location: (_a = context === null || context === void 0 ? void 0 : context.waitlist) === null || _a === void 0 ? void 0 : _a.original_appointment.location,
                appointmentQuery: Object.assign(Object.assign({}, context.appointmentQuery), { periodStart: (_b = context.jumpedToDate) !== null && _b !== void 0 ? _b : context.appointmentQuery.periodStart }),
                periodStart: (_c = context.jumpedToDate) !== null && _c !== void 0 ? _c : context.appointmentQuery.periodStart,
                customerCode: (_d = context.customerCode) !== null && _d !== void 0 ? _d : '',
                services: context.services,
                visibility: context.visibility,
                isInitialDataLoadFromPreviousStep: false,
                availableSlots: [],
                query: {},
                filterBy: context.filterBy,
                jumpedToDate: context.jumpedToDate,
                productName: context.productName,
                apiBaseURL: context.apiBaseURL,
                pull_waitlist_eligibility: true
            }))
        };
    }),
    [setValidatedDateOfBirth]: (0, xstate_1.assign)({
        validatedDateOfBirth: (_ctx, event) => {
            return event.data.validatedDateOfBirth;
        }
    }),
    [setAppointmentQuery]: (0, xstate_1.assign)({
        appointmentQuery: (_context, ev) => {
            const appointment = ev.data.waitlist.original_appointment;
            return {
                patientRel: appointment.patient_relationship,
                locationIds: [
                    appointment.location.location_pma_id ||
                        appointment.location.location_ehr_id
                ],
                purpose: {
                    name: appointment.purpose_name,
                    visit_method: appointment.visit_method
                }
            };
        }
    })
};
exports.default = actions;
//# sourceMappingURL=actions.main.js.map